import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import image from "../../assets/images/logo/noteg_website_logo_2.svg";

const HomeMenu = [
  {
    name: "Business Strategy",
    routerPath: "/business-strategy",
  },
  {
    name: "Data Analytics",
    routerPath: "/data-analytics",
  },
  {
    name: "Ed Tech",
    routerPath: "/ed-tech",
  },
  {
    name: "Change Management",
    routerPath: "/change-management",
  },
  {
    name: "Technology Consulting",
    routerPath: "/Technology-Consulting",
  },
];

const AboutMenu = [
  {
    name: "About Company",
    routerPath: "/about-Company",
  },
  // {
  //   name: "About Us Two",
  //   routerPath: "/about-two",
  // },
];

const ServiceMenu = [
  {
    name: "Application Services",
    routerPath: "/our-industries",
  },
  {
    name: "Infrastructural Services",
    routerPath: "/Infrastructural-Services",
  },
  // {
  //   name: "Service Details",
  //   routerPath: "/service-details",
  // },
];

const TeamMenu = [
  {
    name: "Team Member",
    routerPath: "/team-member",
  },
  {
    name: "Director",
    routerPath: "/Director",
  },
];

const PortfolioMenu = [
  {
    name: "Software and Platform",
    routerPath: "/Software-Platform",
  },
  {
    name: "Public Services",
    routerPath: "/Public-Services",
  },
  {
    name: "Automotive",
    routerPath: "/Automotive",
  },
  {
    name: "Retail",
    routerPath: "/Retail",
  },
];

const BlogMenu = [
  {
    name: "Grid Layout",
    routerPath: "/blog-grid",
  },
  {
    name: "Grid With Sidebar",
    routerPath: "/blog-sidebar",
  },
  {
    name: "Blog Masonry",
    routerPath: "/blog-masonry",
  },
  {
    name: "Blog Standard",
    routerPath: "/blog-standard",
  },
  {
    name: "Blog Details",
    routerPath: "/blog-Details",
  },
];

const Miscellaneous = [
  // {
  //   name: "Testimonials",
  //   routerPath: "/testimonial",
  // },
  // {
  //   name: "Our Pricing",
  //   routerPath: "/price",
  // },
  // {
  //   name: "FAQ",
  //   routerPath: "/faq",
  // },
  // {
  //   name: "404 Error",
  //   routerPath: "/error",
  // },
];

const ThemeMainMenu = () => {
  return (
    <Fragment>
      <ul className="navbar-nav">
        <li className="d-block d-lg-none">
          <div className="logo">
            <Link to="/">
              <img src={image} alt="" width={130} />
            </Link>
          </div>
        </li>
        <li className="nav-item active dropdown">
          <a className="nav-link dropdown-toggle" href="/" role="button">
            Home
          </a>
          {/* <ul className="dropdown-menu">
            {HomeMenu.map((val, i) => (
              <li key={i}>
                <Link to={val.routerPath} className="dropdown-item">
                  <span>{val.name}</span>
                </Link>
              </li>
            ))}
          </ul> */}
        </li>
        <li className="nav-item active dropdown">
          <a className="nav-link dropdown-toggle" href="#" role="button">
            Services
          </a>
          <ul className="dropdown-menu">
            {HomeMenu.map((val, i) => (
              <li key={i}>
                <Link to={val.routerPath} className="dropdown-item">
                  <span>{val.name}</span>
                </Link>
              </li>
            ))}
          </ul>
        </li>
        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="/our-industries">
            Industries
          </a>
          {/* <ul className="dropdown-menu">
            {PortfolioMenu.map((val, i) => (
              <li key={i}>
                <Link to={val.routerPath} className="dropdown-item">
                  <span>{val.name}</span>
                </Link>
              </li>
            ))}
          </ul> */}
        </li>
        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="#" role="button">
            About Us
          </a>
          <ul className="dropdown-menu">
            <li className="dropdown-submenu dropdown">
              <a
                className="dropdown-item dropdown-toggle"
                href="/about-Company"
              >
                <span>About Company</span>
              </a>
            </li>
            {/* <li className="dropdown-submenu dropdown">
              <a className="dropdown-item dropdown-toggle" href="#">
                <span>Services</span>
              </a>
              <ul className="dropdown-menu">
                {ServiceMenu.map((val, i) => (
                  <li key={i}>
                    <Link to={val.routerPath} className="dropdown-item">
                      <span>{val.name}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </li> */}
            <li className="dropdown-submenu dropdown">
              <a className="dropdown-item dropdown-toggle" href="/team-member">
                <span> About Team</span>
              </a>
              {/* <ul className="dropdown-menu">
                {TeamMenu.map((val, i) => (
                  <li key={i}>
                    <Link to={val.routerPath} className="dropdown-item">
                      <span>{val.name}</span>
                    </Link>
                  </li>
                ))}
              </ul> */}
            </li>
            {/* {Miscellaneous.map((val, i) => (
              <li key={i}>
                <Link to={val.routerPath} className="dropdown-item">
                  <span>{val.name}</span>
                </Link>
              </li>
            ))} */}
          </ul>
        </li>

        <li className="nav-item">
          <Link className="nav-link" to="/contact" role="button">
            Contact{" "}
          </Link>
        </li>
      </ul>
    </Fragment>
  );
};
export default ThemeMainMenu;
